<div class="block" style="display: flex; flex-direction: row; gap: 10px; border-bottom: 1px solid #CECECE;" *ngIf="isEditGainThresholdFeatureFlagEnabled">
    <div class="bold" style="width: 180px">Gains Threshold</div>
    <div class="block">
        <div class="block">Set a gains threshold for <span *ngIf="multipleporfolios">the selected portfolios.</span><span *ngIf="!multipleporfolios">this portfolio.</span></div>
        <div class="block" style="max-width: 655px;">
            <irb-expando-link text="How does a gains threshold work in iRebal?">
                <div class="block">Set a capital gains threshold to limit annual taxable gains for a portfolio.</div>
                <div class="block">After generating potential order(s) for a rebalance, iRebal will net the estimated potential gains or losses with the start-of-day year to date realized gain and loss value. If the result exceeds the gains threshold set for the portfolio, iRebal will refuse the order and notify you.</div>
                <div class="">Note: For automated rebalances and scheduled rebalances, iRebal will use the start-of-day realized gain or loss value of the previous business day.</div>
            </irb-expando-link>
        </div>
        <div class="block" style="display: flex; flex-direction: row; gap: 10px" >
            <div>
                <div class="hblock bold">Select a gains threshold type</div>
                <div>
                    <irb-dropdown-filter #gainsThresholdType
                        [(value)]="gainsThresholdTypeDropdownItem"
                        (search)="setGainsThresholdTypes($event)"
                        size="30" hoverPanelWidth="280"
                        (valueChange)="onGainsThresholdTypeChange()"
                    ></irb-dropdown-filter>
                </div>
            </div>
            <div *ngIf="data.gainsThresholdType == 'SET_CUSTOM'">
                <div class="hblock bold">Gains Threshold Amount</div>
                <irb-number-text-box #gainsThresholdAmtInput 
                                [(value)]="data.gainsThresholdAmt"
                                (valueChange)="onGainsThresholdAmtChange()"
                                places="0"
                                [min]="1"
                                [max]="9999999"
                                [isCurrency]="true"
                                [isRequired]="data.gainsThresholdType == 'SET_CUSTOM'"
                                invalidMessage="Please enter whole numbers only"
                                invalidRangeMessage="Please enter a value between $1 and $9,999,999" width="100px"></irb-number-text-box>
            </div>
            <div *ngIf="data.gainsThresholdType == 'USE_GLOBAL_DEFAULT'">
                <div class="hblock bold">Gains Threshold Amount</div>
                <irb-number-text-box  
                                [value]="globalSettings.gainsThresholdAmt == 0 ? null : globalSettings.gainsThresholdAmt"
                                [disabled]="true"
                                places="0"
                                [isCurrency]="true" width="100px"></irb-number-text-box>
            </div>
        </div>
    </div>
</div>
<div style="display: flex; flex-direction: row; gap: 10px">
    <div class="bold" style="width: 180px">Gains Restrictions</div>
    <div>
        <div  class="block">
            <div class="block">Set up capital gains restrictions for <span *ngIf="multipleporfolios">the selected portfolios.</span><span *ngIf="!multipleporfolios">this portfolio.</span></div>
            <div class="block" style="max-width: 655px;">
                <irb-expando-link text="How do capital gains restrictions work in iRebal?">
                    <div class="block"><strong>No restrictions:</strong> iRebal will rebalance portfolios according to model and portfolio settings. Generated trades may include capital gains.</div>
                    <div class="block"><strong>Avoid short-term gains:</strong> iRebal will avoid short-term gains when rebalancing portfolios according to model and portfolio settings. As a result, portfolios may be out of tolerance from their model.</div>
                    <div class=""><strong>Avoid all gains:</strong> iRebal will avoid all capital gains when rebalancing portfolios according to model and portfolio settings. As a result, portfolios may be further out of tolerance from their model.</div>
                </irb-expando-link>
            </div>
            <div class="hblock bold">Capital Gains Restrictions</div>
            <div>
                <irb-dropdown-filter #gainsControlSetting
                        [(value)]="gainsRestrictionDropdownItem"
                        (search)="setPortfolioCapitalGains($event)"
                        size="30" hoverPanelWidth="280"
                        (valueChange)="onGainsRestrictionChange()"
                ></irb-dropdown-filter>
            </div>
        </div>
    </div>
</div>